import { useEffect, useState } from 'react';
import { ColorSchemes, CombinedTheme } from '../Components/ChartOptions/Color/ColorScheme';
import fetchUserThemes from '../api/fetchUserThemes';

const useCombinedColorSchemes = () => {
  const [themes, setThemes] = useState<CombinedTheme[]>(ColorSchemes);

  useEffect(() => {
    let isMounted = true;

    const fetchThemes = async () => {
      try {
        const { themes: userThemesRaw } = await fetchUserThemes();
        if (!isMounted) return;

        const userThemes: CombinedTheme[] = userThemesRaw.map((theme) => ({
          id: theme.themeId,
          name: theme.themeName,
          background: theme.background,
          tableHeaderBackground: theme.tableHeaderBackground,
          colors: theme.colors,
          isUser: true,
        }));

        setThemes([...ColorSchemes, ...userThemes]);
      } catch (err) {
        console.error('Failed to fetch user themes', err);
        setThemes([...ColorSchemes]);
      }
    };

    fetchThemes();

    return () => {
      isMounted = false;
    };
  }, []);

  return themes;
};

export default useCombinedColorSchemes;
